import {dayItemsLiStyle, dayItemsStyle, dayItemTextStyle, dayTitleStyle} from "../../styles/ProgramTabStyles";
import {Box, Typography} from "@mui/material";
import React from "react";
import {useLanguage} from "../../../LanguageContext";
import CommonTab from "./CommonTab";
import {AdventureTextComponent} from "./AdventureTextComponent";


const ProgramTab = ({daysContent}) => {
    const {t} = useLanguage();

    return (
        <CommonTab>
            {daysContent.map((item, index) => {
                const dayContainerStyle = {
                    pt: '0',
                    textAlign: 'center',
                    marginBottom: '50px'
                };
                return (
                    <Box key={index}
                         sx={dayContainerStyle}>
                        {/* Day Title */}
                        <Box
                            sx={{
                                pb: '20px',
                            }}
                        >
                            <Typography
                                style={dayTitleStyle}>
                                {t('day' + (index + 1)).toUpperCase()}
                            </Typography>
                            <Typography
                                style={dayTitleStyle}>
                                {t(item.day_title).toUpperCase()}
                            </Typography>
                        </Box>


                        {/* Content List */}
                        <ul style={dayItemsStyle}>
                            {t(item.content).map((activity, activityIndex) => (
                                <li key={activityIndex} style={dayItemsLiStyle}>
                                    <Typography sx={dayItemTextStyle}>
                                        {activity}
                                    </Typography>
                                </li>
                            ))}
                        </ul>

                        {/*/!* Divider Line *!/*/}
                        {/*{index !== daysContent.length - 1 && (*/}
                        {/*    <Divider style={dividerStyle}/>*/}
                        {/*)}*/}
                    </Box>
                );
            })}
            <Box
                sx={{
                    pt: '24px',
                }}>
                <AdventureTextComponent/>
            </Box>
        </CommonTab>
    )
};

export default ProgramTab;
